const HTML_TAG_PATTERN = /<[^>]+>/;
const HTML_ENTITY_PATTERN = /&(?:#\d+|#x[\da-fA-F]+|[a-zA-Z]+);/;

export function isCmsHtml(value) {
  return (
    typeof value === "string" &&
    (HTML_TAG_PATTERN.test(value) || HTML_ENTITY_PATTERN.test(value))
  );
}

export function sanitizeInlineCmsHtml(value) {
  if (!value || typeof value !== "string") {
    return "";
  }

  let html = value;
  html = html.replace(/<a\b[^>]*>([\s\S]*?)<\/a>/gi, "$1");
  html = html.replace(/<\/?(?:strong|b|u|i|em)\b[^>]*>/gi, "");
  return html.trim();
}

export function cmsPlainText(value) {
  if (!value) {
    return "";
  }

  return value
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>\s*<p>/gi, "\n\n")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .trim();
}

export default function CmsRichText({
  value,
  as: Tag = "span",
  className,
  inlineOnly = false,
}) {
  if (!value) {
    return null;
  }

  const combinedClassName = ["cms-rich-text", className].filter(Boolean).join(" ");
  const content = inlineOnly ? sanitizeInlineCmsHtml(value) : value;

  if (isCmsHtml(content)) {
    return (
      <Tag className={combinedClassName} dangerouslySetInnerHTML={{ __html: content }} />
    );
  }

  return <Tag className={combinedClassName}>{content}</Tag>;
}
